import { app } from '../../../../../app';
import { Controller } from './integrate-hard-token.controller';

app.component('integrateHardToken', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./integrate-hard-token.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-integration/integrate-hard-token/integrate-hard-token.component.js